import { ButtonSize, ButtonType, ButtonTypes } from "./button.type";
import "./button.css";
import Lottie from "react-lottie";
import classNames from "classnames";
import _ from "lodash";
import { animations } from "@/assets/animations";
import React, { useRef } from "react";

export const Button: React.FC<ButtonTypes> = ({
  label,
  loading = false,
  disabled = false,
  onClick = _.noop,
  widthFull = false,
  size = ButtonSize.medium,
  icon,
  type = ButtonType.primary,
  blink = false,
}) => {
  const ref = useRef<any>();
  const loader = () => (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: animations.LOADER,
      }}
      speed={1.2}
    />
  );

  const rippleAnimation = (e: React.MouseEvent<HTMLElement>): void => {
    const ripple = document.createElement("span");
    ripple.classList.add("ripple");
    ref.current.appendChild(ripple);
    const x = e.clientX - (e.target as any).offsetLeft;
    const y = e.clientY - (e.target as any).offsetTop;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;
    setTimeout(() => {
      ripple.remove();
    }, 300);

    onClick();
  };

  return (
    <div
      className={classNames({
        relative: true,
        "w-full": widthFull,
        "w-fit": !widthFull,
      })}>
      {blink && (
        <div className="absolute -left-1 -top-1 h-3 w-3 animate-ping rounded-full bg-bg-primary" />
      )}
      <button
        ref={ref}
        className={classNames({
          "font-satoshiBold row custom-button relative flex cursor-pointer items-center justify-center overflow-hidden rounded-md px-4 text-center text-black":
            true,
          "custom-btn-disabled pointer-events-none":
            (loading || disabled) && type == ButtonType.primary,
          "pointer-events-none bg-red-500/80 text-slate-400":
            (loading || disabled) && type == ButtonType.danger,
          "w-full": widthFull,
          "w-fit": !widthFull,
          "h-[32px] text-sm": size == ButtonSize.small,
          "text-md h-[44px]": size == ButtonSize.medium,
          "h-[52px] text-sm": size == ButtonSize.large,
          "bg-[#121212] text-text-light": type == ButtonType.secondary,
          "custom-primary-btn-hover bg-bg-primary": type == ButtonType.primary,
          "bg-red-500 text-slate-50 hover:bg-red-500/90":
            type == ButtonType.danger,
          "relative h-10 rounded-md border border-primary bg-new-orders-button-gradient px-4 py-2 text-sm text-text-primary":
            type == ButtonType.glass,
        })}
        onClick={_.debounce(rippleAnimation, 300, {
          leading: true,
          trailing: false,
        })}>
        {loading ? loader() : label}
        {icon && (
          <img
            src={icon}
            className="ml-2 h-[20px] w-[20px]"
            alt="P2P.me-button-image"
          />
        )}
      </button>
    </div>
  );
};
